/** @format */

import { useKey } from 'hooks';
import theme from 'theme/themes';

export default () => {
  const { themeMode } = useKey();
  return {
    default: {
      color: 'rgba(0, 0, 0, 0.26)',
      '&.Mui-checked': {
        color: theme.palette.primary[themeMode],
      },
      '&.Mui-disabled': {
        color: 'rgba(0, 0, 0, 0.26)',
      },
      '&.MuiCheckbox-indeterminate': {
        color: theme.palette.primary[themeMode],
      },
    },
    spaceItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid #e0e0e0',
    },
  };
};
